/**
 * 2026-10 — 香港轉數快(FPS)付款資訊面板。
 *
 * 用在三個地方:貼紙結帳完成、購物車結帳完成、訂單狀態頁(待轉帳時)。
 * 沒有 hook,server / client component 都能直接用。
 * fps 物件來自 lib/overseasCheckout.js 的 buildFpsPaymentInfo()。
 */
import LineAddFriendButton from "@/components/public/LineAddFriendButton";
import InstagramDmButton from "@/components/public/InstagramDmButton";

const rowStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "baseline",
  gap: "12px",
  padding: "10px 0",
  borderBottom: "1px solid var(--color-cardBorder)",
  fontSize: "14px",
};

function Row({ label, children, strong }) {
  return (
    <div style={rowStyle}>
      <span style={{ color: "var(--color-textMuted)", flexShrink: 0 }}>
        {label}
      </span>
      <span
        className="select-all"
        style={{
          color: strong ? "var(--color-accent)" : "var(--color-text)",
          fontWeight: strong ? 700 : 500,
          fontSize: strong ? "18px" : "14px",
          textAlign: "right",
          wordBreak: "break-all",
        }}
      >
        {children}
      </span>
    </div>
  );
}

export default function FpsPaymentPanel({ fps, lineUrl, igUrl }) {
  if (!fps) return null;
  // 建單回傳的快照優先;舊回應沒有 lineUrl 時用呼叫端從設定算好的
  const addLineHref = fps.lineUrl || lineUrl || "";
  // IG 同理:快照優先(舊建單回應沒有 igUrl 時用呼叫端從設定算好的)
  const igDmHref = fps.igUrl || igUrl || "";
  const hasFpsAccount = Boolean(fps.fpsId);
  const twd = Number(fps.amountTwd || 0).toLocaleString();
  return (
    <div
      data-testid="fps-payment-panel"
      style={{
        textAlign: "left",
        backgroundColor: "var(--color-cardBg)",
        border: "1px solid var(--color-cardBorder)",
        borderRadius: "var(--radius-md)",
        padding: "16px",
      }}
    >
      <p
        className="text-base font-bold mb-1"
        style={{ color: "var(--color-text)" }}
      >
        請用轉數快 FPS 轉帳付款
      </p>
      <p className="text-xs mb-2" style={{ color: "var(--color-textMuted)" }}>
        訂單已保留,轉帳並經店家確認後才會開始製作。
      </p>

      <Row label="訂單編號">{fps.orderNo}</Row>
      {hasFpsAccount ? (
        <>
          <Row label="FPS 識別碼">{fps.fpsId}</Row>
          {fps.fpsName ? <Row label="收款名">{fps.fpsName}</Row> : null}
        </>
      ) : (
        <Row label="FPS 收款資訊">請私訊官方 LINE 或 Instagram 索取</Row>
      )}
      <Row label="應付金額" strong>
        HK${Number(fps.amountHkd || 0).toLocaleString()}
      </Row>
      <p
        className="text-xs mt-1.5"
        style={{ color: "var(--color-textMuted)", textAlign: "right" }}
      >
        約 NT${twd}(匯率 1 HKD ≈ {fps.hkdRate} TWD)
      </p>

      {fps.instructions ? (
        <p
          className="text-sm mt-4"
          style={{
            color: "var(--color-text)",
            backgroundColor: "rgba(232, 160, 191, 0.12)",
            border: "1px solid rgba(232, 160, 191, 0.35)",
            borderRadius: "8px",
            padding: "10px 12px",
            lineHeight: 1.6,
          }}
        >
          {fps.instructions}
        </p>
      ) : null}
      <LineAddFriendButton href={addLineHref} />
      <InstagramDmButton href={igDmHref} />
      {fps.leadTimeNotice ? (
        <p
          className="text-sm mt-3 font-medium"
          style={{ color: "var(--color-accent)" }}
        >
          ⏳ {fps.leadTimeNotice}
        </p>
      ) : null}
    </div>
  );
}
